import { render } from "./vide-sec.vue?vue&type=template&id=24502526&scoped=true"
import script from "./vide-sec.vue?vue&type=script&lang=js"
export * from "./vide-sec.vue?vue&type=script&lang=js"

import "./vide-sec.vue?vue&type=style&index=0&id=24502526&scoped=true&lang=css"
import "./vide-sec.vue?vue&type=style&index=1&id=24502526&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24502526"]])

export default __exports__